define(
	'dispatcher/AppDispatcher',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"flux"
	],
	function($,_,Backbone,React,Flux){
		return new Flux.Dispatcher();
	}
);
